const axios = require('axios');
const requestAppointment = async ({ date, duration, worker_email, identityInfo, type }) => {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/request/appointment`, {
            date,
            duration,
            worker_email,
            identityInfo,
            type
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting appointment:', error.response?.data || error.message);
        throw error;
    }
};

export default {
    requestAppointment,
};